import {
  Avatar,
  Box,
  Button,
  Stack,
  styled
} from '@mui/material';

import { DateTime } from 'luxon';
import { StyledFormDisplayField } from 'modules';
import { theme } from 'theme';
import * as types from './types';
import { useNavigate } from 'react-router-dom';



const RoundedImg = styled('img')({
  borderRadius: '0.5rem',
  objectFit: 'cover',
  width: '8rem',
  height: '8rem'
});



export type ViewModeSectionProps = {
  dateCreated: DateTime;
  formState: types.IFormState;
};

export const FC = ({
  formState, dateCreated
}: ViewModeSectionProps) => {

  const navigate = useNavigate();
  const handleNav = () => {
    window.open('https://www.meetsherlock.ai/terms', '_');
  };
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: `1px solid ${theme.palette.gray.light20}`,
          height: '9rem',
          width: '9rem',
          borderRadius: '.5rem'
        }}
      >
        {formState.profilePicture
          ? (
            <RoundedImg src={formState.profilePicture.dataUrl} />
          )
          : (
            <Avatar />
          )}
      </Box>

      <Box>
        <StyledFormDisplayField.FC
          label='Full name'
          value={`${formState.firstName} ${formState.lastName}`}
        />

        <StyledFormDisplayField.FC
          label='Email'
          value={formState.preferredEmail || '--'}
        />

        <StyledFormDisplayField.FC
          label='Phone Number'
          value={formState.phoneNumber || '--'}
        />

        <StyledFormDisplayField.FC
          label='Organization'
          value={formState.organizationName || '--'}
        />
      </Box>

      <Box>
        <StyledFormDisplayField.FC
          label='Date Joined'
          value={dateCreated.toFormat('M/dd/yy')}
        />

        <StyledFormDisplayField.FC
          label='Last Login'
          value={DateTime.now().toFormat('M/dd/yy')}
        />

        <StyledFormDisplayField.FC
          label='Password'
          value='password'
        />
        <Stack
          direction='row'
        >
          <Button
            color='primary'
            variant='text'
            onClick={() =>
              window.open('https://www.meetsherlock.ai/terms', '_')}
          >
            Terms
          </Button>
          <Button
            color='primary'
            variant='text'
            onClick={() => window.open('https://www.meetsherlock.ai/privacy', '_')}
          >
            Privacy Policy
          </Button>
        </Stack>

      </Box>
    </>
  );
};
